import { useState } from 'react';
import { VelkeTlacitko } from '../../components/ui.js';

/**
 * Onboarding mistra při prvním přihlášení (UX audit C1 / TOP 8): jednorázová
 * karta se třemi větami — co je deník, co je NÁLEZ, co je podpis. Zavíratelná,
 * stav se pamatuje v localStorage (helfr.uvod.teren.viden). Nejlevnější
 * „nápověda", jaká existuje — bez tour-knihovny.
 */

const KLIC_VIDEN = 'helfr.uvod.teren.viden';

export function jeUvodViden(): boolean {
  try {
    return localStorage.getItem(KLIC_VIDEN) === '1';
  } catch {
    return false;
  }
}

function ulozViden(): void {
  try {
    localStorage.setItem(KLIC_VIDEN, '1');
  } catch {
    // private mode apod. — jednorázová karta je bonus, ne podmínka
  }
}

/** Znovu-vyvolání onboardingu z Menu („Jak to funguje" — blueprint 16 §18). */
export function resetUvod(): void {
  try {
    localStorage.removeItem(KLIC_VIDEN);
  } catch {
    // private mode — bez efektu
  }
}

export function OnboardingKarta() {
  const [viden, setViden] = useState(jeUvodViden);
  if (viden) return null;

  const zavri = () => {
    ulozViden();
    setViden(true);
  };

  // Popup PŘES obsah (ne karta v toku zápisu) — nápověda nesmí odsouvat den.
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-overlay p-4">
      <section
        role="dialog"
        aria-modal="true"
        aria-label="Vítejte v Helfru"
        className="w-full max-w-md rounded-xl border-2 border-primary bg-surface p-5 shadow-xl"
      >
        <h2 className="text-lg font-bold text-text-heading">Tři věci, které tu budete dělat</h2>
        <ol className="mt-3 flex flex-col gap-2 text-base text-text-primary">
          <li>
            <span className="font-bold">① Zapsat den</span> — diktátem, fotkou, nebo kopií
            včerejška. Večer den podepíšete.
          </li>
          <li>
            <span className="font-bold">② NÁLEZ</span> — když něco na stavbě nesedí: foto a pár
            slov, minuta. Kancelář rozhodne, jestli je to vícepráce.
          </li>
          <li>
            <span className="font-bold">③ Podpis dne</span> — podpis den uzamkne a nelze ho vzít
            zpět; opravit jde pak jen opravným záznamem.
          </li>
        </ol>
        <VelkeTlacitko className="mt-4" onClick={zavri}>
          Rozumím
        </VelkeTlacitko>
      </section>
    </div>
  );
}
